
<template>
  <div v-if="showDocuments">
    <div class="community-info">
      <div class="title-list">
        {{ $t('community.communityDocuments.communityDocuments') }}
      </div>
      <div v-if="documents.length>0" class="documents-container" :class="documents.length > 7 ? 'scroll' : null">
        <table class="table-documents">
          <tbody class="document-list">
            <tr v-for="document in documents" :key="document.id">
              <td class="infos-documents">
                <post-attachment id="normal" :document="document" />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="no-doc" v-else>
        {{ $t('community.communityDocuments.noDocuments') }}
      </div>
    </div>
  </div>
</template>

<script>
import PostAttachment from '@/components/post/PostAttachment'
import config from '../../config'

export default {
  name: 'CommunityDocuments',
  components: { PostAttachment },
  props: {
    documents: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      showDocuments: config.ENABLE_DOCUMENT
    }
  }
}
</script>

<style scoped lang="scss">
.community-info {
    margin: 1rem;
    width: 291px;
    max-width: calc(25vw - 16px);
    height: fit-content;
    background-color: #FFFFFF;
    box-shadow: 2px 2px 8px 0 rgba(69, 69, 69, 0.2);
    padding-bottom: 0;
    overflow: hidden;

    .no-doc {
      padding-bottom: 10px;
    }

    .title-list {
        padding: 12px 0;
        color: $black-color;
        font-weight: 600;
        font-size: 16px;
        height: 24px;
    }

    .scroll {
        overflow-y: auto;
    }

    .documents-container {
        float:left;
        width:100%;

        max-height: 308px;
        box-shadow: 2px 2px 8px 0 rgba(69, 69, 69, 0.2);

        .table-documents {
            width: 100%;
            border-collapse:collapse;

            .document-list {
                padding-inline-start: 10px;
                padding-left: 15px;
                text-align: left;

                .infos-documents {
                    display: flex;
                    height: 42px;
                    font-size: 14px;
                    padding-left: 14px;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    max-width: 245px;
                }
            }
        }
    }
}

tr:nth-child(even) {
    background: #FFF
}

tr:nth-child(odd) {
    background: #F8F8F8;
}

table {
    border-spacing: 0;
    border: none;
}

  /* width */
::-webkit-scrollbar {
  width: 10px;
}

/* Track */
::-webkit-scrollbar-track {
  background:  #CCE5E9;
  border-radius: 100px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: rgb(255, 255, 255);
  border-radius: 100px;
  border: 2px solid #CCE5E9;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background:rgb(243, 252, 255);
}
</style>
